import React from 'react';
import { Flex } from '../components/styled/Flex';

interface VerticalLayoutProps {
    align?:string;
    children: React.ReactNode | React.ReactNode[];
    width?: string;
    style?: React.CSSProperties;
    className?: string;
}

export const VerticalLayout: React.FC<VerticalLayoutProps> = (props) => {
    const defaultStyle = {width: props.width !== undefined ? props.width : '100%'};
    const theStyle = {...defaultStyle, ...props.style};
    return (
    
            <Flex
                className={props.className}
                direction={'column'}
                align={props.align !== undefined ? props.align :'space-between'}
                justify={'space-between'}
                wrap={'wrap'}
                style={theStyle}
            >
                {props.children}
            </Flex>
        
    )
};